import React from 'react'
import Header from "components/Headers/Header.js";
import { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Alert, CardFooter, Button, FormGroup, Form, Input, InputGroup} from "reactstrap";
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import {Link} from 'react-router-dom'

function AddNewDevice() {

  const [loadingsubmit, setLoadingsubmit]=useState(true)
  const [error, setError]=useState(false)
  const [message, setMessage]=useState(true)

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const [device, setDevice]=useState('')

  const token = useSelector((state) => state.userLogin.userInfo.token);

  ////////////
  const { t, i18n } = useTranslation();  

  useEffect(() => {
      const storedLanguage = localStorage.getItem('selectedLanguageAFS');
      if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
      }
  }, [i18n]);
  ////////////

  const handleSubmit  = async (e) => {
    
    setLoadingsubmit(false)

    if (device==='') {
      setMessage(t('The device number is empty'))
      setError(true)
      setTimeout(function() {
        setError(false)
      }, 5000);
      setLoadingsubmit(true);
      return;
    } 

    try {

      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      };   
            
      await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/request-add-device/${device}/`, config);

    } catch (error) {
      setMessage(t("Some problems occured, please retry and if the problem persists please send an email to info@automaticfarmsolution.com"))
      setError(true)
      setTimeout(function() {
        setError(false)
      }, 5000);
      setLoadingsubmit(true)
      return;
    } finally {
      setLoadingsubmit(true)
      toggleModal()
    }
    
  }

  return (
    <div>
      <Header/>
      <Container className="mt--15" fluid>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
            <Card>
              <CardHeader>
                <h3>{t('Add New Device')}</h3>
              </CardHeader>
              <CardBody>
                <Form role="form">
                  {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                  <FormGroup>
                    <InputGroup className="input-group-alternative mb-3">
                      <Input 
                        placeholder={t("Device Number")}
                        type="number"
                        controlid='device'
                        value={device} 
                        onChange={(e) => setDevice(e.target.value)} />
                    </InputGroup>
                  </FormGroup>
                </Form>
              </CardBody>
              <CardFooter>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-2">
                    {loadingsubmit ? (
                      <>
                        <Button className="my-4" color="success" type="button" onClick={handleSubmit}>
                          {t("Request to add a new device")} 
                        </Button>
                      </>
                    ):(
                      <>
                        <Button color="success" disabled>
                          <Spinner size="sm">
                            {t("Submitting your request...")}
                          </Spinner>
                          <span>
                            {' '}{t("Submitting your request...")}
                          </span>
                        </Button>
                      </>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-2">
                      <Link to="/">
                          <Button color="primary">
                              {t('Go back')} <i className="fas fa-rotate-left"></i>
                          </Button>
                      </Link>
                  </Col>  
                </Row>
              </CardFooter>
            </Card>
            <Modal isOpen={modal} toggle={toggleModal}>
              <ModalHeader toggle={toggleModal}>{t('Your request has been submitted')}</ModalHeader>
              <ModalBody>
                  <p>{t('A email has been sent to your email.') }</p>
                  <p>{t('One operator will review your request, and send you a email as soon as possible.') }</p>
              </ModalBody>
            </Modal>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AddNewDevice
